import React, { useState } from 'react';
import Sidebar from '../SideBar'; // Adjust the import path as necessary
import Header from '../Header'; // Adjust the import path as necessary
import './MainLayout.css';

const MainLayout = ({ children }) => {
    const [collapsed, setCollapsed] = useState(false);
  
    const toggleSidebar = () => {
      setCollapsed(!collapsed);
    };
  
    return (
      <div className={`layout ${collapsed ? 'collapsed' : ''}`}>
        <Sidebar collapsed={collapsed} toggleSidebar={toggleSidebar} />
        <div className="content">
          {/* Replace the placeholder with the actual Header component */}
          <Header />
          <div className="main-content">
            {children}
          </div>
          {/* <div className="footer">Footer</div> */}
        </div>
      </div>
    );
  };
  
export default MainLayout;
